import { render, staticRenderFns } from "./ServicesView.vue?vue&type=template&id=4abf9229&"
import script from "./ServicesView.vue?vue&type=script&lang=js&"
export * from "./ServicesView.vue?vue&type=script&lang=js&"
import style0 from "./ServicesView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports